import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminApplications from "@/pages/admin/AdminApplications";
import AdminDeals from "@/pages/admin/AdminDeals";
import AdminSuppliers from "@/pages/admin/AdminSuppliers";
import AdminTransactions from "@/pages/admin/AdminTransactions";
import AdminProfiles from "@/pages/admin/AdminProfiles";
import AdminCorridor from "@/pages/admin/AdminCorridor";
import AdminCapitalVelocity from "@/pages/admin/AdminCapitalVelocity";
import AdminSupplyChain from "@/pages/admin/AdminSupplyChain";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminSecurity from "@/pages/admin/AdminSecurity";
import AccessByAppId from "@/pages/AccessByAppId";
import SignIn from "@/pages/SignIn";
import BuyerPaymentPage from "@/pages/BuyerPaymentPage";
import TransactionTrackPage from "@/pages/TransactionTrackPage";
import InvestorDemo from "@/pages/InvestorDemo";
import WelcomeBuyer from "@/pages/welcome/WelcomeBuyer";
import WelcomeExporter from "@/pages/welcome/WelcomeExporter";
import WelcomeDownstream from "@/pages/welcome/WelcomeDownstream";
import WelcomeInvestor from "@/pages/welcome/WelcomeInvestor";
import WhatIsDeltaGreenXPage from "@/pages/public/WhatIsDeltaGreenXPage";
import AIConfidenceEnginePage from "@/pages/public/AIConfidenceEnginePage";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import TermsOfUse from "@/pages/legal/TermsOfUse";
import RiskDisclaimer from "@/pages/legal/RiskDisclaimer";
import InvestorDisclaimer from "@/pages/legal/InvestorDisclaimer";
import RecordingPolicy from "@/pages/legal/RecordingPolicy";
import AIProtection from "@/pages/legal/AIProtection";
import { ApplicationModal } from "@/components/landing/ApplicationModal";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { TourProvider, useTour } from "@/contexts/TourContext";
import InvestorTour from "@/components/investor/InvestorTour";
import { DemoSecurityProvider } from "@/components/security/DemoSecurityProvider";
import { initThirdPartyAnalytics } from "@/lib/analytics";

function GlobalTour() {
  const { open, setOpen } = useTour();
  return open ? <InvestorTour onClose={() => setOpen(false)} /> : null;
}

function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalRole, setModalRole] = useState("buyer");
  const openModal = (role) => { setModalRole(role); setModalOpen(true); };

  // Boot GA4 / Mixpanel once if env IDs are configured. Safe no-op otherwise.
  useEffect(() => { initThirdPartyAnalytics(); }, []);

  return (
    <div className="App">
      <AuthProvider>
        <TourProvider>
          <BrowserRouter>
            <DemoSecurityProvider>
            <Routes>
              <Route path="/" element={<LandingPage openModal={openModal} />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                <Route index element={<AdminOverview />} />
                <Route path="applications" element={<AdminApplications />} />
                <Route path="deals" element={<AdminDeals />} />
                <Route path="suppliers" element={<AdminSuppliers />} />
                <Route path="transactions" element={<AdminTransactions />} />
                <Route path="capital-flows" element={<AdminTransactions />} />
                <Route path="profiles" element={<AdminProfiles />} />
                <Route path="corridor" element={<AdminCorridor />} />
                <Route path="velocity" element={<AdminCapitalVelocity />} />
                <Route path="supply-chain" element={<AdminSupplyChain />} />
                <Route path="analytics" element={<AdminAnalytics />} />
                <Route path="security" element={<AdminSecurity />} />
              </Route>
              <Route path="/pay/:token" element={<BuyerPaymentPage />} />
              <Route path="/track/:token" element={<TransactionTrackPage />} />
              <Route path="/investor-demo" element={<InvestorDemo />} />
              <Route path="/welcome/buyer" element={<WelcomeBuyer />} />
              <Route path="/welcome/exporter" element={<WelcomeExporter />} />
              <Route path="/welcome/supplier" element={<WelcomeExporter />} />
              <Route path="/welcome/downstream" element={<WelcomeDownstream />} />
              <Route path="/welcome/investor" element={<WelcomeInvestor />} />
              <Route path="/what-is-delta-greenx" element={<WhatIsDeltaGreenXPage />} />
              <Route path="/ai-confidence-engine" element={<AIConfidenceEnginePage />} />
              <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/legal/terms-of-use" element={<TermsOfUse />} />
              <Route path="/legal/risk-disclaimer" element={<RiskDisclaimer />} />
              <Route path="/legal/investor-disclaimer" element={<InvestorDisclaimer />} />
              <Route path="/legal/recording-policy" element={<RecordingPolicy />} />
              <Route path="/legal/ai-protection" element={<AIProtection />} />
              <Route path="/access/:appId" element={<AccessByAppId />} />
              <Route path="/sign-in" element={<SignIn />} />
            </Routes>
            <GlobalTour />
            </DemoSecurityProvider>
          </BrowserRouter>
        </TourProvider>
      </AuthProvider>
      <ApplicationModal open={modalOpen} onOpenChange={setModalOpen} role={modalRole} />
    </div>
  );
}

export default App;
